import { render } from "./MiPedido.vue?vue&type=template&id=5808e84e&scoped=true"
import script from "./MiPedido.vue?vue&type=script&lang=js"
export * from "./MiPedido.vue?vue&type=script&lang=js"

import "windi.css?vue&type=style&index=0&id=5808e84e&scoped=true&lang=css&external"
import "./MiPedido.vue?vue&type=style&index=1&id=5808e84e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5808e84e"]])

export default __exports__